<template>
  <PageMenu :menuList="menuList" v-model:activeKey="namespace" @handleMenuClick="handleMenuClick" />

  <div class="property-table">
    <div class="operate-table flex-b-c">
      <a-input-search
        placeholder="请输入编码/名称/描述"
        style="width: 224px"
        allowClear
        v-model:value="searchValue"
        @search="search"
        @change="handleSearchChange"
      />
      <a-button
        v-btn-auth="'meta-property-add'"
        type="primary"
        @click="showAddPropDrawer"
        v-if="namespace === 'custom'"
      >
        <template #icon><plus-outlined /></template>
        新增属性
      </a-button>
    </div>

    <a-table
      class="page-table"
      :dataSource="dataSource"
      :columns="columns"
      :pagination="pagination"
      :rowKey="(record) => record.id"
      :scroll="{ x: 1800, y: `calc(100vh - 370px)` }"
      @change="handleTableChange"
    >
      <!-- <template #customFilterIcon>
        <svg-icon style="width: 16px; height: 16px" iconClass="model-choose" />
      </template> -->
      <template #headerCell="{ column }">
        <template v-if="column.key === 'identifier'">
          <span>
            编码
            <svg-icon
              @click="sort(column.key)"
              :iconClass="
                pagination.sort === column.key && pagination.orderBy === 'DESC'
                  ? 'sort_desc'
                  : pagination.sort === column.key && pagination.orderBy === 'ASC'
                  ? 'sort_asc'
                  : 'model-sort'
              "
            ></svg-icon>
          </span>
        </template>
        <!-- <template v-if="column.key === 'updateTime'">
          <span>
            最后更新
            <svg-icon
              @click="sort('update_time')"
              :iconClass="
                pagination.sort === 'update_time' && pagination.orderBy === 'DESC'
                  ? 'sort_desc'
                  : pagination.sort === 'update_time' && pagination.orderBy === 'ASC'
                  ? 'sort_asc'
                  : 'model-sort'
              "
            ></svg-icon>
          </span>
        </template> -->
      </template>
      <template #bodyCell="{ column, record, index, text }">
        <template v-if="column.key === 'sn'">
          <div>{{ index + 1 + (pagination.current - 1) * pagination.pageSize }}</div>
        </template>
        <template v-if="column.key === 'dataType'">
          <div>
            <svg-icon
              style="margin-right: 8px; font-size: 16px; cursor: pointer"
              icon-class="book"
              @click="seeMoreExpand(record)"
            />
            <span>{{ text }}</span>
          </div>
        </template>
        <!-- <template v-if="column.key === 'expand'">
          <a @click.prevent="seeMoreExpand(record)">查看</a>
        </template> -->
        <template v-if="column.key === 'function'">
          <a @click.prevent="seeFuns(record)">查看</a>
        </template>
        <template v-if="column.key === 'operate'">
          <div class="operate">
            <btnFold>
              <template #bs1>
                <span @click="seeFuns(record)">所属功能</span>
              </template>
              <template #bs2 v-if="checkPermission('meta-property-edit') && namespace === 'custom'">
                <span @click="updateProp(record)">编辑</span>
              </template>
              <template #bs3 v-if="checkPermission('meta-property-copy')">
                <span @click="copyProp(record)">复制</span>
              </template>
              <template
                #bs4
                v-if="checkPermission('meta-property-delete') && namespace === 'custom'"
              >
                <span>
                  <a-popconfirm
                    title="确认删除吗?"
                    placement="left"
                    ok-text="确认删除"
                    @confirm="deleteProp(record)"
                  >
                    <span style="color: #f24949">删除</span>
                  </a-popconfirm>
                </span>
              </template>
            </btnFold>
          </div>
        </template>
      </template>
    </a-table>
  </div>

  <Drawer
    destroyOnClose
    :title="drawerTitle"
    v-model:visible="visible"
    :okText="drawerOkText"
    @ok="handleOK"
    @cancel="drawerCancel"
    :width="530"
  >
    <GeneralProperty v-model:visible="visible" :prop="propRecord" ref="general" />
  </Drawer>

  <Drawer title="扩展信息" v-model:visible="showExpandDrawer" :width="500" :footer="false">
    <ExpandTable :record="selectRecord" />
  </Drawer>

  <div ref="modal" class="modal-table-cover">
    <a-modal
      :width="640"
      :getContainer="() => $refs.modal"
      destroyOnClose
      v-model:visible="showFunModal"
      title="所属功能"
      okText="关闭"
      @ok="
        () => {
          showFunModal = false;
        }
      "
    >
      <OwnFunction :id="selectRecord.id" field="propertyId" :namespace="namespace" />
    </a-modal>
  </div>
</template>

<script setup>
import { PlusOutlined } from "@ant-design/icons-vue";
import PageMenu from "@/components/model/page-menu";
import { ref, onMounted, reactive, watch, inject } from "vue";
import GeneralProperty from "./general-property.vue";
import ExpandTable from "@/components/model/model-definition/expand-table/index.vue";
import OwnFunction from "@/components/model/model-definition/own-function.vue";
import { checkPermission } from "@/plugin/permission";
import btnFold from "@/components/model/btn-fold";
import {
  deleteProperty,
  getStandardProperty,
  getCustomProperty
} from "@/api/console/model/model-definition";
import { columns, menuList } from "./property-table";
import Drawer from "@/components/model/drawer";
import _ from "lodash";
import { checkLink } from "../config";

const namespace = ref("custom");
const instanceId = inject("instanceId");
const general = ref(null);
const handleOK = _.debounce(() => general.value.onSubmit(), 500);
const drawerCancel = () => {
  // this.visible = false;
  general.value.closeDrawer();
};

// -------------------------table-----------------------
let dataSource = ref();
let searchValue = ref("");
let selectRecord = ref({});
const pagination = reactive({
  showTotal: (total) => `共 ${total} 项数据`,
  showQuickJumper: true,
  dataTypes: [],
  // 增加排序
  sort: "update_time",
  orderBy: "DESC",
  current: 1,
  pageSize: 10,
  total: 10,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "30", "50"]
});
// 搜索
let isSearch = ref(true); // 判断输入框输入后，是否按下搜索按钮的变量
let prevSearchValue = ref("");
const handleSearchChange = () => {
  isSearch.value = false;
};
const search = () => {
  isSearch.value = true;
  prevSearchValue.value = searchValue.value;
  pagination.current = 1;
  getTableData();
};
const getTableData = () => {
  const { dataTypes, sort, orderBy } = pagination;
  const request = namespace.value === "custom" ? getCustomProperty : getStandardProperty;
  request(
    {
      keyword: isSearch.value ? searchValue.value : prevSearchValue.value,
      dataTypes,
      sort,
      orderBy
    },
    {
      params: {
        pageSize: pagination.pageSize,
        pageNum: pagination.current
      }
    }
  ).then((res) => {
    dataSource.value = res.data?.result || [];
    pagination.total = res.data?.totalNum * 1 || 0;
  });
};
const handleTableChange = (info, filters) => {
  pagination.dataTypes = filters.dataType;
  pagination.current = info.current;
  pagination.pageSize = info.pageSize;
  getTableData();
};
// 操作按钮组-删除按钮
const deleteProp = async (record) => {
  deleteProperty(record.id).then((res) => {
    if (res.data) getTableData();
  });
};

// 扩展-更多
const showExpandDrawer = ref(false);
const seeMoreExpand = (record) => {
  showExpandDrawer.value = true;
  selectRecord.value = record;
};
// 查询所属功能
const showFunModal = ref(false);
const seeFuns = (record) => {
  selectRecord.value = record;
  showFunModal.value = true;
};
// ------------table-------------

// ------------drawer-------
/**
 * @description: update 字段 0代表新增   1代表编辑  2代表复制
 */
const updateProp = async (record) => {
  const res = await checkLink(record, "propertyId");
  record.islink = res;
  drawerTitle.value = "编辑属性";
  drawerOkText.value = "保存";
  visible.value = true;
  propRecord.value = record;
  propRecord.value.update = 1;
};
/**
 * @description: 复制属性
 * @param {*} record
 */
const copyProp = (record) => {
  drawerTitle.value = "复制属性";
  drawerOkText.value = "复制";
  visible.value = true;
  propRecord.value = record;
  propRecord.value.update = 2;
};

let drawerTitle = ref("");
let drawerOkText = ref("");
let propRecord = reactive({ value: {} });
const visible = ref(false);
watch(visible, (newValue) => {
  if (!newValue) {
    getTableData();
  }
});
const showAddPropDrawer = async () => {
  visible.value = true;
  // 区分新增，编辑drawer
  propRecord.value = {};
  propRecord.value.update = 0;
  drawerTitle.value = "新增属性";
  drawerOkText.value = "新增";
};
// -------drawer--------

onMounted(() => {
  getTableData();
});

// 排序
const sort = (key) => {
  if (key === pagination.sort) {
    // key 相同则切换正序和倒序
    pagination.orderBy = pagination.orderBy === "DESC" ? "ASC" : "DESC";
    if (pagination.orderBy === "DESC") pagination.sort = "update_time";
  } else {
    pagination.sort = key;
    pagination.orderBy = "DESC";
  }
  getTableData();
};

const handleMenuClick = () => {
  dataSource.value = [];
  pagination.current = 1;
  getTableData();
};

watch(
  () => instanceId.value,
  () => {
    handleMenuClick();
  }
);
</script>

<style lang="less" scoped>
.content-head {
  .size(100%, 76px);

  padding: 8px 20px;
  background: @tsl-theme-color1;
  border: 1px solid @tsl-theme-border-color;

  .breadcrumb {
    color: #86909c;
    font-size: 12px;
  }

  .content-title {
    color: #1d2129;
    font-size: 24px;
  }
}

.property-table {
  margin: 24px;
  padding: 24px;
  background: @base-bg-default-color;
  border-radius: 4px;
  .operate-table {
    display: flex;
    margin-bottom: 16px;

    .create {
      .size(80px, 32px);

      margin-right: 10px;
      color: #fff;
      line-height: 32px;
      text-align: center;
      background: #5e66f2;
      border: 1px solid @tsl-theme-border-color;
      cursor: pointer;
    }
  }
}

.extend {
  color: #5e66f2;
  cursor: pointer;
}
.operate {
  color: #5e66f2;
  cursor: pointer;
  span:not(:last-child) {
    padding-right: 16px;
  }
}
a {
  color: #5e66f2;
}
</style>
